/**
 * Removes undefined, null, and empty string values from an object
 *
 * @template T
 * @param {T} obj - The input object to be trimmed
 * @returns {Partial<T>} A new object with all undefined, null, and empty string values removed
 *
 * @example
 * const input = { name: "John", age: null, email: "", city: undefined };
 * const result = trimObj(input);
 * // result = { name: "John" }
 *
 * This function doesn't support nested objects
 */
export default function trimObj<T extends Record<string, unknown>>(obj: T) {
	return Object.fromEntries(
		Object.entries(obj).filter(
			([_, value]) => value !== undefined && value !== null && value !== "",
		),
	) as Partial<T>;
}
